module.exports = __webpack_public_path__ + "static/Patrik-Fingerroos-e3bc565740ee56302456e55bc96170c3.jpg";